import * as React from "react";
import { v4 } from "uuid";

// `toString()` prevents bundlers from trying to `import { useId } from 'react'`
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useReactId = (React as any)["useId".toString()] as (() => string) | undefined;

export const guid = (): string => v4();

export const uuid = (): string => v4();

const useId = (id?: string): string => {
  const _id = useReactId?.();
  return React.useMemo(() => id ?? _id ?? uuid(), [id, _id]);
};

/**
 * Uses React 18's built-in `useId()` when available, or falls back uuid
 */
export { useId };
